import type { RecentSegment, Segment } from './types'

type Keyable = Pick<Segment, 'id' | 'partner_segment_id'>

// Firm segments and partner segments share the numeric id space, so a stable
// row identity has to disambiguate the two. Keep every "segment key" in the
// overview going through here so the prefixes can never drift apart.
export const firmKey = (id: number): string => `s:${id}`
export const partnerKey = (id: number): string => `p:${id}`

export const segmentKey = (segment: Keyable): string =>
  segment.partner_segment_id
    ? partnerKey(segment.partner_segment_id)
    : firmKey(segment.id)

// The server emits exactly one id per RecentSegment (mirroring a SegmentRun
// row), so when partner_segment_id is absent segment_id is always present. The
// `?? 0` is an unreachable type-narrowing fallback: ids start at 1, so the
// resulting `s:0` simply never matches a real segment and the recent drops out.
export const recentKey = (recent: RecentSegment): string =>
  recent.partner_segment_id
    ? partnerKey(recent.partner_segment_id)
    : firmKey(recent.segment_id ?? 0)
